import React, { useMemo } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import classnames from 'classnames';

import InsufficientDataBannerMessage from '../components/insufficient-data-banner-message';
import ItemsSoldOverTime from '../components/graphs/items-sold-over-time-graph';
import { KeyMetrics } from '../components/key-metrics';
import { SalesByCategoryQuantityTable } from '../components/sales-by-category-quantity-table';
import { TopFiveProductsByRevenueTable } from '../components/top-five-products-by-revenue-table';
import { doubleDash } from '../constants';

import messages from './messages';
import style from './style.module.less';
import analyticsStyle from '../analytics-style.module.less';

export const AnalyticsProductReport = ({ chartData }) => {
  const {
    productByCategoryCount,
    productByCategoryAmount,
    productByInterval,
    productCategoryLegend,
    productSummary,
    top5ByAmount,
    top5ByQuantity,
  } = chartData || {};
  const shouldShowNullStates = !productSummary?.totalProductsOrdered;

  const keyMetricsData = useMemo(
    () => [
      {
        id: 1,
        title: <FormattedMessage {...messages.totalItemsOrderedLabel} />,
        value:
          productSummary?.totalProductsOrdered !== undefined ? <FormattedNumber value={productSummary.totalProductsOrdered} /> : doubleDash,
      },
      {
        id: 2,
        title: <FormattedMessage {...messages.uniqueItemsOrderedLabel} />,
        value:
          productSummary?.uniqueProductsOrdered !== undefined ? (
            <FormattedNumber value={productSummary.uniqueProductsOrdered} />
          ) : (
            doubleDash
          ),
      },
      {
        id: 3,
        title: <FormattedMessage {...messages.productsPerOrderLabel} />,
        value:
          productSummary?.avgProductsPerOrder !== undefined ? <FormattedNumber value={productSummary.avgProductsPerOrder} /> : doubleDash,
      },
    ],
    [productSummary],
  );

  return (
    <>
      <KeyMetrics data={keyMetricsData} />
      {shouldShowNullStates && <InsufficientDataBannerMessage />}
      <div className={classnames(style['items-sold-over-time-graph'], analyticsStyle['analytics-section-wrapper'])}>
        <ItemsSoldOverTime data={productByInterval} legendData={productCategoryLegend} shouldShowNullStates={shouldShowNullStates} />
      </div>
      <div className={classnames(style.container, analyticsStyle['analytics-container'])}>
        <div className={analyticsStyle['analytics-section-wrapper']}>
          <SalesByCategoryQuantityTable data={productByCategoryCount} />
        </div>
        <div className={analyticsStyle['analytics-section-wrapper']}>
          <SalesByCategoryQuantityTable byRevenue data={productByCategoryAmount} />
        </div>
      </div>
      <div className={classnames(style.container, analyticsStyle['analytics-container'])}>
        <div className={analyticsStyle['analytics-section-wrapper']}>
          <TopFiveProductsByRevenueTable byQuantity data={top5ByQuantity} />
        </div>
        <div className={analyticsStyle['analytics-section-wrapper']}>
          <TopFiveProductsByRevenueTable data={top5ByAmount} />
        </div>
      </div>
    </>
  );
};
